import React, { ReactElement } from 'react'
import styled from 'styled-components'
import { transformDate, TransformDateFormat } from '../../helpers/dateHelper'

const Styles = styled.div`
  font-size: 12px;
`
interface IValidityProps {
  startDate?: number
  expiryDate?: number
}

function Validity(props: IValidityProps): ReactElement | null {
  const { startDate, expiryDate } = props

  if (!startDate || !expiryDate) return null

  const formattedStartDate = transformDate(
    startDate,
    TransformDateFormat.NumbersAndSlashes,
  )
  const formattedEndDate = transformDate(
    expiryDate,
    TransformDateFormat.NumbersAndSlashes,
  )

  return (
    <Styles>{`Valid from ${formattedStartDate} to ${formattedEndDate}`}</Styles>
  )
}
export default Validity
